import pick from 'lodash/pick';

import { createContexts } from '../../utils';

import type { EventDefinition } from '../../types';

export const call_data_sync_configuration_complete: EventDefinition = {
  getData: (_, eventData = {}) => ({
    ...pick(eventData, ['firstTimeSetup', 'trackersChanged', 'aliasesChanged']),
  }),
  addContexts: ({ eventData } = {}) =>
    createContexts(['integration'], {
      eventData: {
        integration: { slug: eventData?.slug },
      },
    }),
};
